module.exports = __webpack_public_path__ + "static/media/mala.6cd02941.mp3";